import { render } from "./SettingPartner.vue?vue&type=template&id=48dad5fc&scoped=true"
import script from "./SettingPartner.vue?vue&type=script&lang=js"
export * from "./SettingPartner.vue?vue&type=script&lang=js"

import "./SettingPartner.vue?vue&type=style&index=0&id=48dad5fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dad5fc"]])

export default __exports__